import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export const TooltipProvider = TooltipPrimitive.Provider;

/**
 * Used mainly to explain the disabled OAuth buttons on both login screens.
 *
 * `label` widened from `string` to `ReactNode` so a tooltip can carry a small block of content --
 * the quality report hangs its per-check findings off one. `className` overrides the default
 * single-line uppercase treatment, which is right for a caption and wrong for a list.
 */
export function Tooltip({ label, children, className }: { label: ReactNode; children: ReactNode; className?: string }) {
  return (
    <TooltipPrimitive.Root>
      <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
      <TooltipPrimitive.Portal>
        <TooltipPrimitive.Content
          sideOffset={6}
          collisionPadding={12}
          className={cn(
            'z-50 rounded border border-border bg-raised px-2.5 py-1.5 font-mono text-[10px] tracking-[0.1em] text-muted uppercase',
            className
          )}
        >
          {label}
        </TooltipPrimitive.Content>
      </TooltipPrimitive.Portal>
    </TooltipPrimitive.Root>
  );
}
